//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function loadCostsService() {
    try {
        const response = await api.get("/gastos-grupo/ontem");
        return response;
    } catch (error) {
        toast.error("Erro ao carregar os gastos");
        return null;
    }
}